import PropTypes, { node } from "prop-types";

import { createBtnArea } from "./FormSection";
import styles from "./PageContent.module.css";

export default function ActionSection(props) {
  return <div className={styles.headerActions}>{createBtnArea(props)}</div>;
}

ActionSection.propTypes = {
  btnNodes: PropTypes.arrayOf(node),
  btnAdd: PropTypes.object,
  btnInit: PropTypes.object,
  btnSave: PropTypes.object,
  btnDel: PropTypes.object,
  checkAuth: PropTypes.bool,
  additionalBtns: PropTypes.arrayOf(node),
};
